<template>
  <div class="login">
    <XWLoginForm
      @login="handleLogin"
      @missPwd="handleMissPwd"
      @register="handleRegister"
    ></XWLoginForm>
    <ApplyPage ref="applyDialogRef"></ApplyPage>
  </div>
</template>

<script>
import {login} from "@/api/login";
import ApplyPage from "./components/ApplyPage.vue";

export default {
  name: "Login",
  components: {
    ApplyPage,
  },
  data() {
    return {
      currentType: "login",
      // 登陆表
      loginForm: {
        idCard: "342901199904081218",
        password: "123456",
      },
      // 注册表
      registerForm: {
        realname: "",
        idCard: "",
        phoneNumber: "",
        password: "",
      },
      // login
      loginCheck: {
        showIdCardErrInfo: false,
        showPwdErrInfo: false,
      },
    };
  },
  mounted() {
    console.log(this.$route.query.examId);
    if (this.$route.query.examId) {
      console.log("存入session");
      console.log("存入store");
      sessionStorage.setItem("examId", this.$route.query.examId);
      this.$store.commit("examIdChange", sessionStorage.getItem("examId"));
    }
    // 将session更新到store
    // if (sessionStorage.getItem("examId")) {
    //   this.$store.commit("examIdChange", sessionStorage.getItem("examId"));
    // }
    // 页面刷新前将store存入session
    // window.addEventListener("beforeunload", () => {
    //   let params = this.$store.state.examId;
    //   sessionStorage.setItem("examId", params);
    // });
  },
  methods: {
    // 登录
    handleLogin(form) {
      console.log(form);
      let _that = this;
      login(form).then((res) => {
        // console.log(res);
        if (res.data.success) {
          // token
          sessionStorage.setItem(
            _that.config.tokenName,
            res.data.obj.tokenInfo.tokenValue
          );
          // userInfo
          sessionStorage.setItem(
            "userInfo",
            JSON.stringify(res.data.obj.applyInfo)
          );
          _that.$store.commit("loginStateChange", 1);
          _that.$store.commit("userInfoChange", res.data.obj.applyInfo);

          if (_that.$route.query.examId) {
            this.$router.push(
              "/apply/examInfo?examId=" + this.$store.state.examId
            );
          } else {
            this.$router.push("/home");
          }
        }
      });
    },
    // 忘记密码
    handleMissPwd() {
      console.log("忘记密码");
      this.$refs["applyDialogRef"].showDialog();
    },
    // 注册
    handleRegister() {
      console.log("注册");
      this.$router.push("/register");
    },
  },
};
</script>

<style scoped>
.login {
  width: 100%;
  height: 100%;
  background: rgba(240, 242, 245, 0.48);
  background-image: url("../../assets/images/background.svg");
  background-repeat: no-repeat;
  background-color: whitesmoke;
  background-size: 100%;
  -moz-background-size:100% 100%;

  /* background-size: cover; */
  position: relative;
}

.formItem {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.active {
  background-color: #5577ce;
}

.formItemName {
  cursor: pointer;
}

.formBox {
  width: 88%;
  margin: 0 auto;
}

.itemBox {
  padding: 0.8rem 0;
  position: relative;
}

.inputBox {
  display: flex;
  align-items: center;
  height: 2.2rem;
  background-color: #fff;
}

.imgBox {
  width: 2rem;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  padding: 0 5px;
  border-right: 1px solid #f0eaea;
}

.imgBox img {
  width: 80%;
  object-fit: cover;
}

.input {
  flex: 1;
  outline: none;
  border: 0;
  height: 100%;
}

.errorInfo {
  position: absolute;
  bottom: 0;
  left: 0;
  font-size: 0.6rem;
  height: 0.8rem;
  color: #ea3737;
  opacity: 0;
  transition: all 0.4s;
}

.errorInfoShow {
  opacity: 1;
}

.loginBtn {
  width: 100%;
  border: 0;
  height: 2.4rem;
  line-height: 2.4rem;
  font-size: 1rem;
  background-color: #5577ce;
  color: #fff;
  margin: 0.8rem 0;
}

.attention {
  margin-top: 2rem;
  font-size: 0.8rem;
}

.applayUser {
  font-size: 0.8rem;
  margin-bottom: 1rem;
  text-align: right;
  color: #ea3737;

  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/view/login/Login.vue